import { Dispatch } from 'react';
import { useParams } from 'react-router-dom';
import { Form } from 'antd';

import { MilesForm } from 'components';

import { usePostRequest } from 'hooks';

import { SnapCreateOpsComment, SnapDisplayComment } from 'codegen';

import { fields, handleSuccessPostComment, initialValues } from './lib';

const { useForm } = Form;

export const AddComment = ({ setComments }: { setComments: Dispatch<SnapDisplayComment[] | undefined> }) => {
  const { snapId } = useParams();

  const [form] = useForm<typeof initialValues>();

  const [postComment, { loading }] = usePostRequest<{ comments: SnapDisplayComment[] }, SnapCreateOpsComment>({
    url: `/snaps/${snapId}/comments`,
    options: {
      onSuccess: handleSuccessPostComment(form, setComments),
    },
  });

  return (
    <div className='mt-5'>
      <MilesForm
        form={form}
        fields={fields}
        wrapperCol={{ span: 24 }}
        initialValues={initialValues}
        onFinish={({ comment }) => postComment({ payload: { comment } })}
        buttonProps={{
          ghost: true,
          label: 'Add Comment',
          loading,
        }}
      />
    </div>
  );
};
